import styled from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import Widget from '~/src/components/Widget';

export const WidgetContent = styled(Widget.ContentBlock)`
    padding-top: 32px;
`;

export const WidgetName = styled(Widget.Name)`
    margin-bottom: 16px;
`;

export const WidgetInfo = styled(Widget.Info)`
    margin-bottom: 24px;
`;

export const CapabilityItem = styled.li`
    display: inline-flex;
    align-items: center;
    ${FONTS.XS};
    color: ${COLORS.TextSecondary};
    padding: 4px 12px 4px 4px;
    border-radius: ${BorderRadius.componentRadius};
    background-color: ${COLORS.BgMain};

    &:not(:last-child) {
        margin-bottom: 12px;
    }
`;

export const CapabilityIcon = styled.img`
    width: 29px;
    height: 29px;
    margin-right: 8px;
`;
